module.exports = __webpack_public_path__ + "img/ercode.33d0de6d.png";